import { Link } from "@material-ui/core";
import React, { useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Redirect, useHistory } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import Close from "../assets/images/close.svg";
import useOnClickOutside from "../hooks/useOutsideClickhandler";
import "./authLayout.scss";
import popimageapple from "../assets/images/popimageapple.svg";
import popimagegoogle from "../assets/images/popimagegoogle.svg";
import { logout, registerComplete } from "../redux/auth/actions";
import {useCookies} from 'react-cookie';
import { passcodeKey, tokenKey, usernameKey } from "../utils/constants";

const AuthLayout = ({ children }) => {
  let history = useHistory();
  let dispatch = useDispatch();
  const { accessToken } = useSelector((state) => state.auth);
  const [modalShow, setModalShow] = React.useState(false);
  const [cookies, setCookie] = useCookies([usernameKey, passcodeKey, tokenKey]);
  
  if (accessToken) {
  return <Redirect to="/" />;
  }

  const handleBackButton = () => {
    //To Remove all the details from store and navigate back to login
    localStorage.clear();
    dispatch(registerComplete());
    setCookie(usernameKey, null);
    setCookie(passcodeKey, null);
    setCookie(tokenKey, null);
    dispatch(logout());
    history.push("/login");
  };

  return (
    <div>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="modal-upload"
      >
        <div className="uploadDocuments">
          <div className="header">
            App Link
            <img
              crossOrigin="anonymous"
              style={{ cursor: "pointer" }}
              src={Close}
              onClick={() => {
                setModalShow(false);
              }}
              alt="Close"
            />
          </div>
          <hr className="heading_line" />

          <main>
            <div className="playstorelink">
              <a
                className="googleplay"
                target="_blank" rel="noreferrer"
                href="https://play.google.com/store/apps/details?id=com.doctall"
              >
                <img alt="" crossOrigin="anonymous" src={popimagegoogle} />
              </a>

              <a
                className="applestore"
                target="_blank"
                href="https://apps.apple.com/ng/app/doctall/id1544455716"
                rel="noreferrer"
              >
                <img crossOrigin="anonymous" src={popimageapple} alt="img" />
              </a>
            </div>
          </main>
        </div>
      </Modal>

      <div
        className="container-fluid"
        style={{ padding: "0", height: "100%", backgroundColor: "#F2F8F9" }}
      >
        <div className="row" style={{ margin: 0 }}>
          <div className="innerDiv1 col-lg-6" style={{ padding: "0" }}>
            <div className="loginImage">
              {/* <img className="imgBackground" src={require('../assets/AuthImages/bg1.svg').default}/> */}
              <div className="overlay"></div>
              <h1 className="loginHeadText">
                Easiest way to access medical tests & results.
              </h1>

              {/* <p className='loginParaText'>Get personalized care from certified local and international doctors online </p> */}
            </div>
          </div>
          <div className="innerDiv2 col-lg-6" style={{ padding: "0" }}>
            <div className="logoHead">
              <Link to="/">
                <img
                  crossOrigin="anonymous"
                  src={require("../assets/images/logo.svg").default}
                  alt=""
                />
              </Link>
              {window.location.pathname === "/confirmVerification" && (
                <small
                  style={{
                    cursor: "pointer",
                    marginTop: "30px",
                    color: "#163e8c",
                    fontSize: "18px",
                  }}
                  onClick={handleBackButton}
                >
                  <img
                    crossOrigin="anonymous"
                    style={{ height: "12px", width: "13px" }}
                    src={require("../assets/images/back.svg").default}
                    alt=""
                  />{" "}
                  Back
                </small>
              )}
              <div />
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
